import SpineWrapper from '@Core/Animation/SpineWrapper';
import { GameComponent } from '@Core/GameComponent/GameComponent';
import { GameScene } from '@Core/GameScene/GameScene';
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';

export class GameBackground extends GameComponent {
    static readonly PRELOADER_BG_SPINE_KEY: string = 'preloaderBackground';
    static readonly BG_SPINE_KEY: string = 'gameBackground';
    static readonly SKIN_NAME: string = 'default';
    public scene: GameScene;
    private preloaderBackground: SpineWrapper;
    private background: SpineWrapper;

    constructor(scene: GameScene) {
        super(scene);
        this.scene = scene;
        Logger.log(LoggerLevel.Constructor, {
            source: LoggerSource.Game,
            message: 'GameBackground constructor'
        });
    }

    public onCreate(): void {
        this.preloaderBackground = new SpineWrapper(
            this.scene,
            {
                x: this.scene.screen.width / 2,
                y: this.scene.screen.height / 2
            },
            {
                dataKey: GameBackground.PRELOADER_BG_SPINE_KEY,
                skinName: GameBackground.SKIN_NAME
            },
            true
        )!;

        this.background = new SpineWrapper(
            this.scene,
            {
                x: this.scene.screen.width / 2,
                y: this.scene.screen.height / 2
            },
            { dataKey: GameBackground.BG_SPINE_KEY, skinName: GameBackground.SKIN_NAME },
            true
        )!;
    }

    public getBackgroundSpine(): SpineWrapper {
        return this.background;
    }
}
